import moment from 'moment';
import { ISlotsOwnSlotList } from '../../type/b2bBuyerSellerType';

export const groupSlotsByDate = (
  slots: ISlotsOwnSlotList[] | undefined
): Record<string, ISlotsOwnSlotList[]> => {
  return (
    slots?.reduce((acc: Record<string, ISlotsOwnSlotList[]>, curr) => {
      const currentDate = moment(curr.start_time).format('YYYY-MM-DD');

      if (!acc[currentDate]) {
        acc[currentDate] = [];
      }
      acc[currentDate].push(curr);

      return acc;
    }, {}) || {}
  );
};
export const groupSlotsByStaffId = (
  slots: ISlotsOwnSlotList[] | undefined
): Record<string, ISlotsOwnSlotList[]> => {
  return (
    slots?.reduce((acc: Record<string, ISlotsOwnSlotList[]>, curr) => {
      const currentStaffId = curr.staff_id;

      if (!acc[currentStaffId]) {
        acc[currentStaffId] = [];
      }
      acc[currentStaffId].push(curr);

      return acc;
    }, {}) || {}
  );
};

export const calculateDuration = (start: string, end: string): string => {
  const startTime = moment(start, 'YYYY-MM-DD HH:mm:ss');
  const endTime = moment(end, 'YYYY-MM-DD HH:mm:ss');
  const duration = moment.duration(endTime.diff(startTime));
  const hours = duration.hours();
  const minutes = duration.minutes();

  let result = '';

  if (hours > 0) {
    result += `${hours} hour${hours !== 1 ? 's' : ''}`;
  }

  if (minutes > 0) {
    if (result) result += ' ';
    result += `${minutes} minute${minutes !== 1 ? 's' : ''}`;
  }

  return result || '0 minutes'; // If both hours and minutes are 0
};

export const amPmTimeShowForSlot = (start: string, end: string) => {
  if (start && end) {
    const startTime = moment(start).format('hh:mm a');
    const endTime = moment(end).format('hh:mm a');
    return `${startTime}-${endTime}`;
  }

  return '';
};
